import { DashboardEntitiesSummary } from 'pages/Dashboard/components/DashboardEntitiesSummary/DashboardEntitiesSummary';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { EntitiesSummary } from 'types/embedded/dashboard';

type Props = {
  isLoading: boolean;
  summary?: EntitiesSummary;
  error?: string;
};

export const DashboardPropvidersSummary: React.FC<Props> = ({ isLoading, summary, error }) => {
  const translate = useTypedTranslate();

  return (
    <DashboardEntitiesSummary
      description={translate('app.dashboard.entitiesSummary.cardDescription')}
      entityName={translate('app.dashboard.entitiesSummary.provider')}
      error={error}
      isLoading={isLoading}
      items={summary?.items}
      title={translate('app.dashboard.entitiesSummary.providersCardTitle')}
    />
  );
};
